import { Card, Col, Row, Grid } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { formatNumber } from '../../../../utils/helpers/format.helper';

const { useBreakpoint } = Grid;

const ClientStatistics = () => {
    const { t } = useTranslation('dashboard');
    const screens = useBreakpoint();
    const { clientStatistics: { data } } = useSelector((state: RootState) => state.dashboard);

    const getCardPadding = () => {
        if (screens.xxl || screens.xl) {
            return screens.xxl ? 24 : 16;
        }
        if (screens.lg || screens.md) return 16;
    };

    const basePadding = getCardPadding();

    const getColProps = () => {
        if (screens.xxl || screens.xl) {
            return {
                flex: "1 1 20%",
                style: { maxWidth: '20%' }
            };
        }
        return {
            lg: 8,
            md: 8,
            sm: 12,
            xs: 24
        };
    };

    const colProps = getColProps();

    return (
        <Row gutter={[screens.xxl ? 24 : screens.xl ? 16 : 24, 24]} style={screens.xxl || screens.xl ? { display: 'flex', flexWrap: 'nowrap' } : {}}>
            <Col {...colProps}>
                <Card bodyStyle={{ padding: basePadding }} style={{ height: '100%' }}>
                    <Row>
                        <Col xs={24} className='base-card-title'>
                            {t('total_customer_count')}
                        </Col>
                        <Col xs={24} className='base-card-value' style={{
                            color: '#000',
                            whiteSpace: 'nowrap'
                        }}>
                            {(data?.companyCount || 0)}
                        </Col>
                    </Row>
                </Card>
            </Col>

            <Col {...colProps}>
                <Card bodyStyle={{ padding: basePadding }} style={{ height: '100%' }}>
                    <Row>
                        <Col xs={24} className='base-card-title'>
                            {t('connected_business_count')}
                        </Col>
                        <Col xs={24} className='base-card-value' style={{
                            color: '#000',
                            whiteSpace: 'nowrap'
                        }}>
                            {(data?.childCompanyCount || 0)}
                        </Col>
                    </Row>
                </Card>
            </Col>

            <Col {...colProps}>
                <Card bodyStyle={{ padding: basePadding }} style={{ height: '100%' }}>
                    <Row>
                        <Col xs={24} className='base-card-title'>
                            {t('user_count')}
                        </Col>
                        <Col xs={24} className='base-card-value' style={{
                            color: '#000',
                            whiteSpace: 'nowrap'
                        }}>
                            {(data?.userCount || 0)}
                        </Col>
                    </Row>
                </Card>
            </Col>

            <Col {...colProps}>
                <Card bodyStyle={{ padding: basePadding }} style={{ height: '100%' }}>
                    <Row>
                        <Col xs={24} className='base-card-title'>
                            {t('active_customer_count')}
                        </Col>
                        <Col xs={24} className='base-card-value' style={{
                            color: '#000',
                            whiteSpace: 'nowrap'
                        }}>
                            {(data?.activeCompanyCount || 0)}
                        </Col>
                    </Row>
                </Card>
            </Col>

            <Col {...colProps}>
                <Card bodyStyle={{ padding: basePadding }} style={{ height: '100%' }}>
                    <Row>
                        <Col xs={24} className='base-card-title'>
                            {t('passive_customer_count')}
                        </Col>
                        <Col xs={24} className='base-card-value' style={{
                            color: '#000',
                            whiteSpace: 'nowrap'
                        }}>
                            {(data?.passiveCompanyCount || 0)}
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    )
}

export default ClientStatistics